import { TSection } from "@data-types/offer/live/Section";

export enum EventBodyTabs {
	Markets = "MARKETS",
	Statistics = "STATS",
	MyBets = "MY_BETS",
}

export enum StatisticsGroups {
	LiveStats = "LIVE_STATS",
	PlayerStats = "PLAYER_STATS",
	StreakStats = "STREAK_STATS",
	FullStats = "FULL_STATS",
	EventInsights = "EVENT_INSIGHTS",
	TeamStandings = "TEAM_STANDINGS",
	TeamLineups = "TEAM_LINEUPS",
}

export const DEFAULT_SECTION = TSection.Matches;
